module.exports = "<div class=\"promo-content\">\r\n    <p><strong>Please upgrade to JustisOne Professional for more information about this case, including key passages and precedent analysis.</strong></p>\r\n    <p>{{> upgrade-button}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/open-promo-content.html
// module id = 443
// module chunks = 1